export default (workingState, templateId, targetStatus, currentUser) => {
  const statusChangedWorkingState = { ...workingState };
  const template = statusChangedWorkingState.templatesWorkingState.find(
    template => template.id === templateId,
  );
  template.status = targetStatus;
  delete template.addedBy;
  if (targetStatus === 'inCart') {
    template.addedBy = currentUser;
  }
  return statusChangedWorkingState;
};
